module.exports = __webpack_public_path__ + "img/storage13.63119dcb.jpg";